import React from 'react';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { SpecifiedCybersecurityOrForensicProviderFormValues } from '../../modals/CyberForensicProviderModal';
import { CyberForensicProviderModalConfig } from '../../modals/CyberForensicProviderModal';
import { useLocale } from '../../../../../../providers/LocaleProvider';
import type { CyberForensicProviders } from '../../../../../../api/types/rater-x-preset';

const SpecifiedCyberOrForensicProvider = (props: AmendatoryLineItemProps) => {
  const { language } = useLocale();
  const handleAddProvider = (
    formValues: SpecifiedCybersecurityOrForensicProviderFormValues
  ) => {
    const _providers = formatProvidersForState(formValues);

    props.setCoverage({
      id: props.id,
      value: {
        props: {
          providers: {
            values: _providers as unknown as CyberForensicProviders[],
          },
        },
      },
    });
  };

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(CyberForensicProviderModalConfig, {
          data: {
            onSubmit: handleAddProvider,
            language,
            defaultValues: getDefaultProviderValues(
              props.value?.props?.providers?.values as CyberForensicProviders[]
            ),
          },
        })}
      >
        Add/Edit ({String(props.value?.props?.providers?.values?.length ?? 0)})
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default SpecifiedCyberOrForensicProvider;

export function getDefaultProviderValues(
  values: CyberForensicProviders[] | undefined
) {
  if (!values) {
    return [];
  }

  return values.map((value) => {
    return {
      name: value.props.name.value ?? '',
      rate: value.props.rate.value ?? 0,
    };
  });
}

export function formatProvidersForState(
  formValues: SpecifiedCybersecurityOrForensicProviderFormValues
) {
  return formValues.providers.map((provider) => {
    return {
      props: Object.keys(provider).reduce((acc, key) => {
        const value = provider[key as keyof typeof provider];
        return {
          ...acc,
          [key]: { value },
        };
      }, {} as CyberForensicProviders),
    };
  });
}
